import { createAsyncThunk } from '@reduxjs/toolkit';
import { _teleradiologyuserUrls } from '@custom/Utils/constants/apiUrls';

const deleteReviewStatus = createAsyncThunk('deleteReviewStatus', async (body:any) => {
    try {
      const token = sessionStorage.getItem('token') || localStorage.getItem('token');
      let url = _teleradiologyuserUrls.deleteReviewStatus;
      let response = await fetch(url, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body:JSON.stringify(body)
      });

      if (!response.ok) {
        throw new Error('Failed to execute');
      }

      return await response.json();
    } catch (error) {
      return Promise.reject(error);
    }
  });



export default deleteReviewStatus;
